import { render, staticRenderFns } from "./ModalConfirmarEdicao.vue?vue&type=template&id=275ed968&lang=pug"
import script from "./ModalConfirmarEdicao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarEdicao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarEdicao.vue?vue&type=style&index=0&id=275ed968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports